import React, { memo } from 'react';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Typography } from '../material-ui/Typography';

import { getCurrentTaskNumber, getCurrentTaskDate } from '../../selectors/screen';
import { useSize } from '../hooks/useSize';
import { getRouteText } from './tools';

const routesWithoutFlightTask = ['reports', 'library', 'messages'];
const MIN_WIDTH_SHOW_NUMBER = 590;
const MIN_WIDTH_SHOW_FULL_TASKS = 510;

export const AppBarTitle = memo(() => {
    const route = useSelector((state) => get(state, 'router.location.pathname'));
    const taskNumber = useSelector(getCurrentTaskNumber);
    const taskDate = useSelector(getCurrentTaskDate);
    const isAppBarWithoutTaskInfo = routesWithoutFlightTask.indexOf(route.substring(1)) + 1;
    const showText = isAppBarWithoutTaskInfo && true;
    const { t: translate } = useTranslation();
    const text = getRouteText(isAppBarWithoutTaskInfo, route);
    const { width } = useSize();
    const showNumber = width >= MIN_WIDTH_SHOW_NUMBER;
    const showFullTasks = width >= MIN_WIDTH_SHOW_FULL_TASKS;

    return (
        <Typography variant="h6" style={{ flexGrow: 1 }} color="inherit">
            {showText ? (
                translate(`labels.${text}`)
            ) : taskNumber ? (
                <>
                    <span className="app-bar__title-start">{`${translate('labels.flightTask')} `}</span>
                    {showNumber ? <span>{taskNumber}</span> : <span>{taskNumber.replace('№ ', '')}</span>}
                    <span className="app-bar__title-date">{` (${taskDate})`}</span>
                </>
            ) : (
                translate(`labels.${showFullTasks ? 'flightTasks' : 'tasks'}`)
            )}
        </Typography>
    );
});

AppBarTitle.displayName = 'AppBarTitle';
